import useFetchURL from '../../../../elements/Hooks/useFetchURL'
import React, { Component, Fragment } from 'react'
import { List, Popover, Row, Tag, Tooltip } from 'antd'
import { sessionItemVal, strVal } from '../../../../modules/Utils'
import StaffStatus from '../../../../elements/StaffStatus'
import MemberAvatarView from '../../../../elements/Members/MemberAvatarView'
import { compose } from 'recompose'
import withSpinning from '../../../../elements/HOC/withSpinning'
import moment from 'moment'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import ContactDetailsDisplay from '../../PhoneBook/ContactDetailsDisplay'
import _ from 'lodash'

function StaffList(props) {
  const { list, fetch } = props

  const { data, fetching, fetchURL } = useFetchURL(
    `foxxapi/user/location/office/`,
    undefined,
    undefined,
    undefined,
    true,
  )

  return (
    <List
      size="small"
      dataSource={list}
      bordered={false}
      header={
        <Fragment>
          <h3>
            Available Staff <RefreshButton onClick={fetch} />
          </h3>
        </Fragment>
      }
      renderItem={item => {
        const userIP = _.get(item, 'loginIp')
        const office = _.get(data, 'office', [''])
        let type = office.includes(userIP) ? 'KL OFFICE' : 'REMOTE'
        let color = office.includes(userIP) ? '#2db7f5' : '#87d068'
        return (
          <List.Item>
            <List.Item.Meta
              avatar={
                <>
                  <MemberAvatarView id={item.image} />
                  <br />
                  {userIP && userIP !== '127.0.0.1' && <Tag color={color}>{type}</Tag>}
                </>
              }
              title={
                <Row>
                  <Popover
                    content={<ContactDetailsDisplay member={item} />}
                    title={<h3>Contact Details</h3>}>
                    <a>{item.nickname}</a>
                  </Popover>
                  <Tooltip title={`Last update: ${moment(item.lastUpdate).fromNow()}`}>
                    <StaffStatus
                      style={{ float: 'right' }}
                      value={sessionItemVal('attendance_status_dropdown', item.status)}
                      _key={item.status}
                    />
                  </Tooltip>
                </Row>
              }
              description={
                <>
                  <span
                    style={{
                      float: 'left',
                    }}>
                    {item.department}
                    <br />
                    {strVal(item.location, 'country.countryName')}
                  </span>
                </>
              }
            />
          </List.Item>
        )
      }}
    />
  )
}

StaffList.propTypes = {}
StaffList.defaultProps = {}

export default compose(withSpinning)(StaffList)
